<template>
  <p class="text-xl-center font-weight-black">
      BEEP BOOP: Loading the data...
  </p>
</template>

<script>
export default {

};
</script>
